<template>
  <el-dialog
      :visible.sync="visible"
      title="采购合同修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="外销合同编号：" prop="orderCode">
            <el-input
                size="mini"
                v-model="dataForm.orderCode"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批次号：" prop="batchCode">
            <el-input
                size="mini"
                v-model="dataForm.batchCode"
                :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="product.name" label="品名：">
            <el-input
                :disabled="!canProductEdit"
                size="mini"
                v-model="dataForm.product.name"
                placeholder="请输入品名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="color" label="颜色：">
            <el-input
                :disabled="!canProductEdit"
                size="mini"
                v-model="dataForm.product.color"
                placeholder="请输入颜色"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="size" label="规格：">
            <el-input
                :disabled="!canProductEdit"
                size="mini"
                v-model="dataForm.product.size"
                placeholder="请输入规格"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="attr1" label="幅宽：">
            <el-input
                :disabled="!canProductEdit"
                size="mini"
                v-model="dataForm.product.attr1"
                placeholder="请输入幅宽"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="attr2" label="克重：">
            <el-input
                :disabled="!canProductEdit"
                size="mini"
                v-model="dataForm.product.attr2"
                placeholder="请输入克重"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="count" label="采购数量：">
            <el-input
                size="mini"
                v-model="dataForm.count"
                placeholder="请输入采购数量"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="amount" label="采购单价：">
            <el-input
                size="mini"
                v-model="dataForm.amount"
                placeholder="请输入采购单价"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="companyId" label="供应商：">
            <company v-model="dataForm.companyId" :disabled="!canProductEdit"></company>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="storageId" label="收货工厂：">
            <storages v-model="dataForm.storageId" :showBtn="false"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <div class="dialog-footer">
        <div>
          <tool-tip>已产生发货信息的采购订单无法修改物料信息</tool-tip>
        </div>
        <div>
          <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle()" size="mini">{{
              $t('confirm')
            }}
          </el-button>
        </div>
      </div>

    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { moneyValidator } from '@/utils/validate'

export default {
  components: {},
  data () {
    return {
      id: '',
      dataForm: {
        id: '',
        orderCode: '',
        batchCode: '',
        product: {
          name: '',
          color: '',
          size: '',
          attr1: '',
          attr2: ''
        },
        count: '',
        amount: '',
        companyId: '',
        storageId: '',
        refStoreLogCount: 0
      },
      visible: false
    }
  },
  computed: {
    canProductEdit () {
      if (!this.dataForm) {
        return false
      }
      if (!this.dataForm.product) {
        return false
      }
      return this.dataForm.refStoreLogCount === 0
    },
    dataRule () {
      return {
        agreementCode: [
          { required: true, message: '请填写名称', trigger: 'change' },
        ],
        'product.name': [{ required: true, message: '请填写品名', trigger: 'change' }],
        amount: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        companyId: [
          { required: true, message: '请选择供应商', trigger: 'change' },
        ],
        storageId: [
          { required: true, message: '请选择收货仓库', trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              let n = parseInt(value)
              if (isNaN(n) || n === 0) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    reset () {
      this.dataForm = {
        id: '',
        orderCode: '',
        batchCode: '',
        product: {
          name: '',
          color: '',
          size: '',
          attr1: '',
          attr2: ''
        },
        count: '',
        amount: '',
        companyId: '',
        storageId: '',
        refStoreLogCount: 0
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
      }
    },
    async init () {
      this.reset()
      this.visible = true
      this.$nextTick(() => {
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    async getInfo () {
      const data = await this.$api2.get(`/erp/purchase/${this.id}`)
      this.dataForm = {
        ...this.dataForm,
        ...data,
      }
    },
    async doSave () {
      const loading = this.$loading()
      let postForm = {
        ...this.dataForm
      }
      try{
        const data = await this.$api2.post(`/erp/purchase/edit`, postForm)
        this.$emit('change')
        this.$message.success('保存成功')
        this.visible = false
      }finally {
        loading.close()
      }

    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            this.doSave()
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
